import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/user-outline-grey.svg'
import _imports_1 from '@/assets/img/icon/bus-front-outline-grey.svg'


const _hoisted_1 = { class: "flex flex-row-reverse mb-5" }
const _hoisted_2 = { class: "lg:w-1/4 w-full" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "border-grey-3" }
const _hoisted_6 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "text-primary text-xs font-normal border-primary py-1 px-2 rounded-md background-blue-4"
}
const _hoisted_10 = { class: "flex items-center gap-3 ml-5" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "user"
}, null, -1)
const _hoisted_13 = { class: "text-grey text-sm font-medium" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "bus"
}, null, -1)
const _hoisted_17 = { class: "text-grey text-sm font-medium" }
const _hoisted_18 = { class: "flex items-end" }
const _hoisted_19 = { class: "text-2xl text-green font-extrabold" }
const _hoisted_20 = {
  key: 0,
  class: "border-grey-3"
}
const _hoisted_21 = { class: "px-3" }
const _hoisted_22 = { class: "flex items-center justify-between background-blue-4 py-4 px-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary text-xl font-bold" }, "Total Non-Tunai", -1)
const _hoisted_24 = { class: "text-primary text-xl font-bold" }
const _hoisted_25 = { class: "mt-40px flex justify-end" }
const _hoisted_26 = { class: "flex items-center justify-end" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Closing Stat")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Closing Stat")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm mt-8px" }, "* Pastikan PP yang dikoreksi sudah benar sebelum Anda melakukan Closing Stat", -1)

import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import Card from 'primevue/card'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Paginator from '@/views/components/paginator/Paginator.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import Popper from 'vue3-popper'
import EmptyState from '@/views/components/list/EmptyState.vue'
import { useStore } from 'vuex'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import '../detail-table.scss'
import numberFormat from '@/utils/helpers/numberFormat'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import Button from 'primevue/button'
import moment from 'moment'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import { checkProhibitedRoles } from '@/utils/helpers/checkProhibitedRole'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import TicketListDetail from './detail/TicketListDetail.vue'
import SnackListDetail from './detail/SnackListDetail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenedList',
  setup(__props) {

const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const Snackendpoint = '/ticket/v1/Snacks'
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const router = useRouter()
const store = useStore()
const placeholder = ref('Cari Disini...')
const emptyTable = ref('Data setoran belum tersedia')
const inputSearch = ref('')
const dataSource = ref([]) as any
const selectedData = ref(null) as any
const dataSourceDetail = ref([]) as any
const dataSourceSummary = ref(null) as any
const positionTabs = ref(0)

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [] as any
})

const filtersDetail = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 5,
  totalRecords: 0,
  custom: [] as any
})

const tabHeader = ref([
  { title: 'SETORAN KARCIS', value: 0 },
  { title: 'SETORAN SNACK', value: 1 }
])

const attrModalConfirmation = reactive({
  show: false,
  title: 'Stat PP Sudah Sesuai?',
  subTitle: 'Apakah Anda yakin data stat PP sudah sesuai?',
  btnSubmitTitle: 'Approve Setoran',
  imgContent: require('@/assets/img/modal-confirmation/closing-stat.svg')
})

const onSearch = () => {
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const toDetailPage = (data: any) => {
  console.log('data', data)
  if (selectedData.value?.Id === data.Id) {
    selectedData.value = null
    filtersDetail.value.pageNumber = 1
    filtersDetail.value.totalRecords = 0
    dataSourceDetail.value = []
  } else {
    selectedData.value = data
    positionTabs.value = 0
    dataSourceDetail.value = []
    // eslint-disable-next-line no-use-before-define
    // getAllDataDetail()
  }
}

const onChangePage = (evt: any) => {
  filters.value.pageNumber = evt.page + 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onChangePageDetail = ({ page, rows }: any) => {
  filtersDetail.value.pageNumber = page + 1
  filtersDetail.value.pageSize = rows
  // eslint-disable-next-line no-use-before-define
  getAllDataDetail()
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Approved`, returnUrlPrams(filters.value)).then((response) => {
    const { error, result, count } = response
    console.log('res', result)
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getAllDataSummary = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Approved/Preview`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataSourceSummary.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getAllDataDetail = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Approved/${selectedData.value?.Id}/Tickets`, returnUrlPrams(filtersDetail.value)).then((response) => {
    const { error, result, count } = response
    console.log('res', result)
    if (!error) {
      filtersDetail.value.totalRecords = count
      dataSourceDetail.value = result
    }
  })
  store.dispatch('hideLoading')
}

const showConfirmModal = () => {
  attrModalConfirmation.show = true
}

const hideConfirmModal = () => {
  attrModalConfirmation.show = false
}

const showPrintedStat = (item: any) => {
  console.log('item', item)
  const token = localStorage.getItem('ut')
  const routeData = router.resolve({ name: 'reports-detail', params: { typeReport: `${item.Query}?${item.Parameter}=${item.closedId}` } })
  window.open(routeData.href, '_blank')
}

const tabsChange = (val: any) => {
  console.log('change')
  positionTabs.value = val
}

// const printClosedStat = async (closedId: string) => {
//   store.dispatch('showLoading')
//   await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Completed/${closedId}/Export`).then((response) => {
//     const { error, result } = response
//     if (!error) {
//       const params = {
//         ...result,
//         closedId
//       }
//       showPrintedStat(params)
//       // window.location.reload()
//     }
//     hideConfirmModal()
//     selectedData.value = null
//     filters.value.pageNumber = 1
//     filters.value.pageSize = 10
//     getAllData()
//     getAllDataSummary()
//   })
//   store.dispatch('hideLoading')
// }

const printClosedStat = async (closedId: string) => {
  store.dispatch('showLoading')
  const payload = {}
  await apiUseCase.getBlob(`${transactionPpsEndpoint}/NonCash/Completed/${closedId}/Export`).then((response) => {
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `laporan Setoran Non-Tunai (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
      hideConfirmModal()
      selectedData.value = null
      filters.value.pageNumber = 1
      filters.value.pageSize = 10
      getAllData()
      getAllDataSummary()
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const transferSnack = async (id: any) => {
  store.dispatch('showLoading')
  const building = await store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  console.log('store', store.state)
  const payload = {
    FromBuildingId: null,
    FromBuildingName: null,
    ToBuildingId: building.id,
    ToBuildingName: building.name,
    ReferenceId: id,
    TransferType: 'ReturnFromRoster',
    SnackTransferItems: [] as any
  }

  // eslint-disable-next-line no-unused-expressions, array-callback-return
  payload.SnackTransferItems = dataSourceSummary.value?.TransactionPpSnackSummary.TransactionPpSnackStocks.map((data: any) => ({
    SnackId: data.SnackId,
    Quantity: data.QuantityLeft
  }))

  try {
    await apiOpenUseCase.postWithNoId(`${Snackendpoint}/Transfer`, payload).then((response) => {
      const { result, error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Snack berhasil disetor',
          group: 'bc',
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        // printClosedStat(id)
        hideConfirmModal()
        getAllData()
        getAllDataSummary()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal menyetor snack',
          detail: message,
          group: 'bc',
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal menyimpan snack',
      detail: error,
      group: 'bc',
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const progressClosingStat = async () => {
  store.dispatch('showLoading')
  // const payload = dataSource.value.map((data: any) => data.Id)
  const payload = dataSourceSummary.value?.TransactionPpIds
  try {
    await apiUseCase.postWithNoId(`${transactionPpsEndpoint}/NonCash/Approved/Close`, payload).then((response) => {
      const { error, result, message } = response
      if (!error) {
        // transferSnack(result.Id)
        $toast.add({
          severity: 'success',
          // summary: 'Gagal!',
          detail: 'Berhasil Closing Stat PP',
          group: 'bc',
          closable: false,
          life: 3000
        })
        hideConfirmModal()
        getAllData()
        getAllDataSummary()
      } else {
        // hideConfirmModal()
        $toast.add({
          severity: 'error',
          summary: 'Gagal!',
          detail: 'Gagal Closing Stat PP karena terdapat Stat yang sudah ditutup. Silahkan hubungi Admin.',
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal!',
      detail: 'Gagal Closing Stat PP karena terdapat Stat yang sudah ditutup. Silahkan hubungi Admin.',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmitAct = async () => {
  // console.log('storeX', store.state)
  // if (checkProhibitedRoles(['Admin'])) {
  //   $toast.add({
  //     severity: 'error',
  //     summary: 'Gagal!',
  //     detail: 'Closing hanya bisa dilakukan oleh Setoran',
  //     group: 'bc',
  //     closable: false,
  //     life: 3000
  //   })
  // } else {
  //   progressClosingStat()
  // }
  progressClosingStat()
}

onMounted(() => {
  getAllData()
  getAllDataSummary()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InputIconRight, {
            class: "input-search-header-custom",
            placeholder: placeholder.value,
            modelValue: inputSearch.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
            canClick: true,
            icon: _unref($icon).svg.searchEva,
            onSubmitInput: onSearch,
            onKeyup: _withKeys(onSearch, ["enter"])
          }, null, 8, ["placeholder", "modelValue", "icon", "onKeyup"])
        ])
      ]),
      (filters.value.totalRecords === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
              return (_openBlock(), _createElementBlock("div", { key: data }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["lg:flex justify-between items-center px-4 py-4", _unref(selectedData)?.Id === data.Id ? 'background-blue-4' : ''])
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (toDetailPage(data))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(`cursor-pointer pi pi-angle-${_unref(selectedData)?.Id === data.Id ? 'down' : 'right'}`)
                          }, null, 2)
                        ], 8, _hoisted_7),
                        _createElementVNode("div", {
                          onClick: ($event: any) => (toDetailPage(data)),
                          class: "cursor-pointer text-base font-bold"
                        }, _toDisplayString(data?.TrxId ?? '-'), 9, _hoisted_8),
                        (data.HasNonCash)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString('NON-TUNAI')))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, _toDisplayString(`Kondektur: ${data?.CondecturName ?? '-'}`), 1)
                        ]),
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, _toDisplayString(`Nopol: ${data?.VehicleRegNumber ?? '-'}`), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(currencyNumberFormat)(data?.TotalNonCashTicketAmount ?? 0)), 1)
                    ])
                  ], 2)
                ]),
                (_unref(selectedData)?.Id === data.Id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(HjpTabView, {
                        onTabsChange: tabsChange,
                        tabHeader: tabHeader.value
                      }, null, 8, ["tabHeader"]),
                      _createElementVNode("div", _hoisted_21, [
                        (positionTabs.value === 0)
                          ? (_openBlock(), _createBlock(TicketListDetail, {
                              key: 0,
                              transactionId: _unref(selectedData)?.Id
                            }, null, 8, ["transactionId"]))
                          : _createCommentVNode("", true),
                        (positionTabs.value === 1)
                          ? (_openBlock(), _createBlock(SnackListDetail, {
                              key: 1,
                              transactionId: _unref(selectedData)?.Id
                            }, null, 8, ["transactionId"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(currencyNumberFormat)(_unref(dataSourceSummary)?.TotalNonCashTicketAmount ?? 0)), 1)
            ]),
            _createVNode(Paginator, {
              class: "trayek-pagination",
              rows: filters.value.pageSize,
              totalRecords: filters.value.totalRecords,
              rowsPerPageOptions: [5, 10, 15, 20, 25],
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_26, [
                  (!_unref(checkProhibitedRoles)(['Admin']))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_unref(Popper), {
                          arrow: "",
                          hover: "",
                          placement: "top",
                          content: "Hanya User dengan Role Setoran saja yang dapat melakukan Closing"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                              class: "btn-primary mr-1",
                              disabled: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(Button), {
                        key: 1,
                        class: "btn-primary mr-1",
                        onClick: showConfirmModal
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      }))
                ]),
                _hoisted_30
              ])
            ])
          ]))
    ]),
    _createVNode(HjpConfirmationModal, {
      show: attrModalConfirmation.show,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      imgContent: attrModalConfirmation.imgContent,
      onOnSubmit: onSubmitAct,
      onHideDialog: hideConfirmModal
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent"])
  ], 64))
}
}

})